<template>
  <div class="r-date common-flex common-justify-between" :style="{width:width+'px'}">
      <div class="title">{{config.label}}<span style="color:red" v-if="config.must">*</span></div>
      <!-- <input type="text" v-model="config.inputvalue"> -->
      <DatePicker @on-change="changeDate" style="width: 200px" type="date" v-model="config.dateValue" placeholder=" "></DatePicker>
  </div>
</template>

<script>

export default {
  name: "r-date",
  data() {
    return {

    };
  },
  /*label 标题
    must 是否必填,
    type 类型,
    dateValue  选择日期
  */
  props:{
      config:Object,
      width:{
        type:[Number,String],
        default:350
      }
  },
  methods:{
    changeDate(e){
      this.config.dateValue = e
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-input{
    border:none;
    box-shadow:none;
    text-align:right;
}
/deep/.ivu-input-suffix{
    display:none;
    padding-right: 0;
}
.r-date{
    // width: 350px;
    padding-bottom: 12px;
    border-bottom: 1px solid #B4BAC3;
    .title{
        width: 170px;
        line-height: 32px;

    }
    input{
        width: 170px;
        text-align: right;
        height: 32px;
        line-height: 32px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/r-date.vue